import { removeEmptyTrailingPTags } from '@unifyapps/editor/editors/RichTextEditor/utils';

const getIsTextInputKey =
  ({ input }: { input: string | undefined }) =>
  (event: KeyboardEvent) => {
    // Ignore if ctrl/cmd/alt/meta keys are pressed
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return false;
    }

    // Printable characters (letters, numbers, symbols)
    if (event.key.length === 1) {
      return true;
    }

    // Spacebar
    if (event.key === 'Space' || event.keyCode === 32) {
      return true;
    }

    const textRemovalKeys = ['Backspace', 'Delete'];
    if (input && removeEmptyTrailingPTags(input) && textRemovalKeys.includes(event.key)) {
      return true;
    }

    return false;
  };

export default getIsTextInputKey;
